// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"TagInputInput-inputContainer-18fav"};